(() => {
  const storageKey = 'bamboo_google_click_ids_v1';
  const trackedParams = [
    'gclid',
    'gbraid',
    'wbraid',
    'gad_source',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
  ];

  const hasStorage = () => {
    try {
      localStorage.setItem('__bamboo_ads_test__', '1');
      localStorage.removeItem('__bamboo_ads_test__');
      return true;
    } catch (_error) {
      return false;
    }
  };

  const readStored = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '{}');
    } catch (_error) {
      return {};
    }
  };

  const writeStored = (value) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (_error) {
      return;
    }
  };

  const currentUrl = () => window.location.href.split('#')[0];

  const collectAttribution = () => {
    const stored = readStored();
    const params = new URLSearchParams(window.location.search);
    const next = { ...stored };
    let changed = false;

    trackedParams.forEach((key) => {
      const value = params.get(key);
      if (!value || next[key] === value) return;
      next[key] = value;
      changed = true;
    });

    if (changed) {
      next.landing_page = currentUrl();
      next.landing_timestamp = new Date().toISOString();
      writeStored(next);
    }

    return changed ? next : stored;
  };

  const buildDesiredAttributes = (data) => {
    const attributes = {};
    Object.entries(data || {}).forEach(([key, value]) => {
      if (!value) return;
      attributes[key] = String(value).slice(0, 255);
    });
    return attributes;
  };

  const syncCartAttributes = async (desiredAttributes) => {
    if (!window.routes?.cart_url || !window.routes?.cart_update_url || !Object.keys(desiredAttributes).length) return;

    const cartResponse = await fetch(`${window.routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!cartResponse.ok) return;

    const cart = await cartResponse.json();
    const existingAttributes = cart.attributes || {};
    const mergedAttributes = { ...existingAttributes };
    let changed = false;

    Object.entries(desiredAttributes).forEach(([key, value]) => {
      if (mergedAttributes[key] === value) return;
      mergedAttributes[key] = value;
      changed = true;
    });

    if (!changed) return;

    await fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: mergedAttributes }),
    });
  };

  if (!window.fetch || !hasStorage()) return;

  const attribution = collectAttribution();
  if (!attribution.gclid && !attribution.gbraid && !attribution.wbraid) return;

  syncCartAttributes(buildDesiredAttributes(attribution)).catch(() => {});
})();
